import React, { useRef, useMemo, useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button, Card, Col, Form, ProgressBar, Row } from 'react-bootstrap';
import AlertaFrecuenciaChart from './AlertaFrecuenciaChart';
import Flex from '../../../../../components/common/Flex';
import dayjs from 'dayjs';
import { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import FalconCardHeader from '../../../../../components/common/FalconCardHeader';
import alertasFiltrosStore from '../../../../../lib/store/alertas_filtros_store';
import { paginadorAlertasStore } from '../../../../../lib/store/paginador_store';
import { Divider } from '@mui/material';
import ProgressBarWithComponents from '../../../../../components/common/ProgressBarWithComponents';
import { delay } from 'underscore';
import { createRenderCustomHeader } from '../../../../../components/datepicker/CustomDatePickerHeader';
import '../../../../../styles/datepicker.css';

const convertirFechaOmisiones = (fechaStr, esOmisiones = false) => {
    if (!esOmisiones || !fechaStr) return fechaStr;

    try {
        // Para omisiones: convertir UTC a local
        return dayjs.utc(fechaStr).local().format('YYYY-MM-DD HH:mm:ss');
    } catch (error) {
        return fechaStr; // Si hay error, devolver original
    }
};

const AlertaFrecuencia = ({
    data,
    dataHours = [],
    dataBefore = [],
    dataBeforeHours = [],
    total = 0,
    totalBefore = 0,
    isSingleDay = false,
    isSingleDayBefore = false,
    title,
    alertaFiltrada,
    vehiculoFiltrado,
    isLoading,
    loadingComponents,
    calculateTotalProgress,
    debugMetrics,
    dataProgress
}) => {
    const store = alertasFiltrosStore();
    const [totalCarga, editarTotalCarga] = useState([]);

    // Establecer valores iniciales para las fechas
    const getDiff = (fechaInicio, fechaFin) => {
        let timeDiff = fechaFin.getTime() - fechaInicio.getTime();
        let daysDiff = (Math.ceil(timeDiff / (1000 * 60 * 60 * 24))) - 1;
        return daysDiff;
    }

    // Inicializar fechas con el día actual

    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0); // Inicio del día (00:00:00)
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59); // Fin del día (23:59:59)

    const [startDate, setStartDate] = useState(store.fechaInicio);
    const [endDate, setEndDate] = useState(store.fechaFin);
    const [startDateBefore, setStartDateBefore] = useState(store.fechaInicioBefore);
    const [endDateBefore, setEndDateBefore] = useState(store.fechaFinBefore);

    const chartRef = useRef(null);

    const esOmisiones = title?.toLowerCase().includes('omisiones') || false;
    //console.log(`[AlertaFrecuencia] Es omisiones: ${esOmisiones}, título: "${title}"`);


    // ✅ DETERMINAR QUÉ DATOS USAR PARA EL PERÍODO ACTUAL
    //     const dataToUse = useMemo(() => {
    //     // Si hay un solo día, usar datos por horas
    //     if (isSingleDay && dataHours && dataHours.length > 0) {
    //         console.log('🕐 Usando datos por HORAS para período actual');
    //         return dataHours;
    //     }
    //     // Si hay múltiples días, usar datos por días (relativos)
    //     if (!isSingleDay && data && data.length > 0) {
    //         console.log('📅 Usando datos por DÍAS RELATIVOS para período actual');
    //         return data;
    //     }
    //     return [];
    // }, [data, dataHours, isSingleDay]);

    // ✅ SIMPLIFICAR - Los datos ya vienen procesados desde index.js
    const dataToUse = useMemo(() => {
        if (isSingleDay && dataHours && dataHours.length > 0) {
            //console.log('🕐 Usando datos por HORAS para período actual');
            return dataHours; // ✅ No convertir de nuevo
        } else if (!isSingleDay && data && data.length > 0) {
            //console.log('📅 Usando datos por DÍAS para período actual');
            return data; // ✅ No convertir de nuevo
        }
        return [];
    }, [data, dataHours, isSingleDay]);

    const dataBeforeToUse = useMemo(() => {
        if (isSingleDay && isSingleDayBefore && dataBeforeHours && dataBeforeHours.length > 0) {
            //console.log('🕐 Usando datos por HORAS para período anterior');
            return dataBeforeHours; // ✅ No convertir de nuevo
        } else if (!isSingleDay && dataBefore && dataBefore.length > 0) {
            //console.log('📅 Usando datos por DÍAS para período anterior');
            return dataBefore; // ✅ No convertir de nuevo
        }
        return [];
    }, [dataBefore, dataBeforeHours, isSingleDay, isSingleDayBefore]);

    // const dataToUse = useMemo(() => {
    //     // Si hay un solo día, usar datos por horas
    //     if (isSingleDay && dataHours && dataHours.length > 0) {
    //         return dataHours;
    //     }
    //     // De lo contrario, usar datos por día
    //     return data || [];
    // }, [data, dataHours, isSingleDay]);

    // ✅ DETERMINAR QUÉ DATOS USAR PARA EL PERÍODO ANTERIOR
    //     const dataBeforeToUse = useMemo(() => {
    //     // Si hay un solo día en ambos períodos, usar datos por horas
    //     if (isSingleDay && isSingleDayBefore && dataBeforeHours && dataBeforeHours.length > 0) {
    //         console.log('🕐 Usando datos por HORAS para período anterior');
    //         return dataBeforeHours;
    //     }
    //     // Si hay múltiples días, usar datos por días relativos
    //     if (!isSingleDay && dataBefore && dataBefore.length > 0) {
    //         console.log('📅 Usando datos por DÍAS RELATIVOS para período anterior');
    //         return dataBefore;
    //     }
    //     return [];
    // }, [dataBefore, dataBeforeHours, isSingleDay, isSingleDayBefore]);




    // const dataBeforeToUse = useMemo(() => {
    //     // Si hay un solo día en ambos períodos, usar datos por horas
    //     if (isSingleDayBefore && isSingleDay && dataBeforeHours && dataBeforeHours.length > 0) {
    //         return dataBeforeHours;
    //     }
    //     // De lo contrario, usar datos por día
    //     return dataBefore || [];
    // }, [dataBefore, dataBeforeHours, isSingleDay, isSingleDayBefore]);

    // ✅ PROCESAR DATOS ACTUALES PARA EL GRÁFICO
    // const processedCurrentData = useMemo(() => {
    //     if (!dataToUse || dataToUse.length === 0) return [];

    //     console.log('🔍 Datos originales recibidos en AlertaFrecuencia (actual):', dataToUse.slice(0, 3));
    //     console.log('🔍 Total de elementos en dataToUse:', dataToUse.length);
    //     console.log('🔍 Estructura del primer elemento:', dataToUse[0]);

    //     const mapped = dataToUse.map((item, index) => {
    //         // Estructura esperada: {fecha: "2025-01-24", cantidad: 407} o {hora: "14:00", cantidad: 407}
    //         if (item.fecha !== undefined && item.cantidad !== undefined) {
    //             return {
    //                 date: item.fecha,      // ✅ fecha -> date
    //                 hour: item.hora,       // ✅ hora -> hour (puede ser undefined)
    //                 count: item.cantidad   // ✅ cantidad -> count
    //             };
    //         }

    //         // Si ya viene con la estructura esperada por el gráfico
    //         if (item.date !== undefined && item.count !== undefined) {
    //             return item;
    //         }

    //         // ✅ FALLBACK para casos inesperados
    //         return {
    //             date: item.fecha || item.date || `Período ${index + 1}`,
    //             hour: item.hora || item.hour || `${index}:00`,
    //             count: item.cantidad || item.count || 0
    //         };
    //     });

    //     console.log('🔍 Datos mapeados en AlertaFrecuencia (actual):', mapped.slice(0, 3));
    //     return mapped;
    // }, [dataToUse]);
    useEffect(() => {
        if (dataProgress) {
            editarTotalCarga(dataProgress);
        } else {
            editarTotalCarga([]);
        }
    }, [dataProgress]);

    useEffect(() => {
        if (isLoading === false) {
            const barra = document.getElementById("prg_master");
            if (barra) {
                barra.innerHTML = "";
            }
        }
    }, [isLoading]);

    // Handle functions for DatePicker onChange
    const handleStartDateChange = (date) => {
        const mismoDia = startDate.getDate() === date.getDate() && startDate.getMonth() === date.getMonth() && startDate.getFullYear() === date.getFullYear();
        const nuevaFecha = mismoDia ? date : new Date(date.getFullYear(), date.getMonth(), date.getDate(), startDate.getHours(), startDate.getMinutes(), startDate.getSeconds());
        setStartDate(nuevaFecha);
        store.editarFechaInicio(nuevaFecha);
        setStartDateBefore(nuevaFecha);
        store.editarFechaInicioBefore(nuevaFecha);

        const mismoDiaEnd = endDate.getDate() === date.getDate() && endDate.getMonth() === date.getMonth() && endDate.getFullYear() === date.getFullYear();
        if (mismoDiaEnd) {
            let adjustedEndDate;
            if (endDate.getHours() < date.getHours() ||
                (endDate.getHours() === date.getHours() && endDate.getMinutes() < date.getMinutes()) ||
                (endDate.getHours() === date.getHours() && endDate.getMinutes() === date.getMinutes() && endDate.getSeconds() < date.getSeconds())) {
                adjustedEndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59);
            } else {
                adjustedEndDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), endDate.getHours(), endDate.getMinutes(), endDate.getSeconds());
            }
            setEndDate(adjustedEndDate);
            // Calcular el rango con el nuevo endDate
            const rangeMs = adjustedEndDate.getTime() - nuevaFecha.getTime();
            const newEndDateBefore = new Date(nuevaFecha.getTime() + rangeMs);
            setEndDateBefore(newEndDateBefore);
            store.editarFechaFinBefore(newEndDateBefore);
        } else {
            // Calcular el rango entre nuevaFecha y endDate, y aplicarlo a startDateBefore (que es nuevaFecha) para endDateBefore
            const rangeMs = endDate.getTime() - nuevaFecha.getTime();
            const newEndDateBefore = new Date(nuevaFecha.getTime() + rangeMs);
            setEndDateBefore(newEndDateBefore);
            store.editarFechaFinBefore(newEndDateBefore);

            if (nuevaFecha.getDate() > endDate.getDate() || nuevaFecha.getMonth() > endDate.getMonth() || nuevaFecha.getFullYear() > endDate.getFullYear()) {
                setEndDate(new Date(nuevaFecha.getFullYear(), nuevaFecha.getMonth(), nuevaFecha.getDate(), 23, 59, 59));
                setEndDateBefore(new Date(nuevaFecha.getFullYear(), nuevaFecha.getMonth(), nuevaFecha.getDate(), 23, 59, 59));
            } else if (nuevaFecha.getDate() === endDate.getDate() && nuevaFecha.getMonth() === endDate.getMonth() && nuevaFecha.getFullYear() === endDate.getFullYear()) {
                // Same day, check time
                let adjustedEndDate;
                if (endDate.getHours() < nuevaFecha.getHours() ||
                    (endDate.getHours() === nuevaFecha.getHours() && endDate.getMinutes() < nuevaFecha.getMinutes()) ||
                    (endDate.getHours() === nuevaFecha.getHours() && endDate.getMinutes() === nuevaFecha.getMinutes() && endDate.getSeconds() < nuevaFecha.getSeconds())) {
                    adjustedEndDate = new Date(nuevaFecha.getFullYear(), nuevaFecha.getMonth(), nuevaFecha.getDate(), 23, 59, 59);
                } else {
                    adjustedEndDate = new Date(nuevaFecha.getFullYear(), nuevaFecha.getMonth(), nuevaFecha.getDate(), endDate.getHours(), endDate.getMinutes(), endDate.getSeconds());
                }
                setEndDate(adjustedEndDate);
                setEndDateBefore(adjustedEndDate);
            }
        }
    };

    const handleEndDateChange = (date) => {
        const mismoDia = endDate.getDate() === date.getDate() && endDate.getMonth() === date.getMonth() && endDate.getFullYear() === date.getFullYear();
        const nuevaFecha = mismoDia ? date : new Date(date.getFullYear(), date.getMonth(), date.getDate(), endDate.getHours(), endDate.getMinutes(), endDate.getSeconds());

        let newEndDate;
        // Si es el mismo día que startDate y la hora nueva es anterior a startDate, ajusta a la hora de startDate
        if (date.getDate() === startDate.getDate() && (startDate.getHours() > date.getHours() || startDate.getMinutes() > date.getMinutes() || startDate.getSeconds() > date.getSeconds())) {
            newEndDate = nuevaFecha;
            setStartDate(newEndDate);
            store.editarFechaInicio(newEndDate);
            setStartDateBefore(newEndDate);
            store.editarFechaInicioBefore(newEndDate);
            setEndDate(newEndDate);
            store.editarFechaFin(newEndDate);
        } else {
            // Caso general: actualiza con nuevaFecha
            newEndDate = nuevaFecha;
            setEndDate(newEndDate);
            store.editarFechaFin(newEndDate);
        }

        // Calcular el rango entre startDate y newEndDate, y aplicarlo a startDateBefore para endDateBefore
        const rangeMs = newEndDate.getTime() - startDate.getTime();
        const newEndDateBefore = new Date(startDateBefore.getTime() + rangeMs);
        setEndDateBefore(newEndDateBefore);
        store.editarFechaFinBefore(newEndDateBefore);
    };

    const handleStartDateBeforeChange = (date) => {
        setStartDateBefore(date);
        store.editarFechaInicioBefore(date);
        let daysDiff = getDiff(startDate, endDate);
        let end = new Date(date.getFullYear(), date.getMonth(), date.getDate() + daysDiff, endDate.getHours(), endDate.getMinutes(), endDate.getSeconds());
        setEndDateBefore(end);
        store.editarFechaFinBefore(end);
    };

    const handleEndDateBeforeChange = (date) => {
        setEndDateBefore(date);
        store.editarFechaFinBefore(date);
    };

    // ✅ useMemo para renderHeaders - DESPUÉS de las funciones handler
    const renderIniHeader = useMemo(
        () => (props) => createRenderCustomHeader(startDate, handleStartDateChange)(props),
        [startDate, handleStartDateChange]
    );
    const renderEndHeader = useMemo(
        () => (props) => createRenderCustomHeader(endDate, handleEndDateChange)(props),
        [endDate, handleEndDateChange]
    );

    const renderIniHeaderBefore = useMemo(
        () => (props) => createRenderCustomHeader(startDateBefore, handleStartDateBeforeChange)(props),
        [startDateBefore, handleStartDateBeforeChange]
    );
    const renderEndHeaderBefore = useMemo(
        () => (props) => createRenderCustomHeader(endDateBefore, handleEndDateBeforeChange)(props),
        [endDateBefore, handleEndDateBeforeChange]
    );

    const processedCurrentData = useMemo(() => {
        if (!dataToUse || dataToUse.length === 0) return [];

        //console.log('🔍 Datos originales recibidos en AlertaFrecuencia (actual):', dataToUse);
        //console.log('🔍 Total de elementos en dataToUse:', dataToUse.length);
        //console.log('🔍 Estructura del primer elemento:', dataToUse[0]);

        // ✅ LOG ESPECIAL PARA OMISIONES
        if (esOmisiones && dataToUse.length > 0) {
            //console.log('[AlertaFrecuencia] Datos con fechas convertidas:', {
            //    original: data?.[0] || dataHours?.[0],
            //    convertido: dataToUse[0]
            //});
        }

        const mapped = dataToUse.map((item, index) => {
            // Estructura esperada: {fecha: "2025-01-24", cantidad: 407} o {hora: "14:00", cantidad: 407}
            if (item.fecha !== undefined && item.cantidad !== undefined) {
                return {
                    date: item.fecha,      // ✅ fecha -> date (ya convertida si es omisiones)
                    hour: item.hora,       // ✅ hora -> hour (ya convertida si es omisiones)
                    count: item.cantidad   // ✅ cantidad -> count
                };
            }

            // Si ya viene con la estructura esperada por el gráfico
            if (item.date !== undefined && item.count !== undefined) {
                return item;
            }

            // ✅ FALLBACK para casos inesperados
            return {
                date: item.fecha || item.date || `Período ${index + 1}`,
                hour: item.hora || item.hour || `${index}:00`,
                count: item.cantidad || item.count || 0
            };
        });

        //console.log('🔍 Datos mapeados en AlertaFrecuencia (actual):', mapped.slice(0, 3));
        return mapped;
    }, [dataToUse, esOmisiones]);


    // ✅ PROCESAR DATOS ANTERIORES PARA EL GRÁFICO
    // const processedBeforeData = useMemo(() => {
    //     if (!dataBeforeToUse || dataBeforeToUse.length === 0) return [];

    //     console.log('🔍 Datos originales recibidos en AlertaFrecuencia (anterior):', dataBeforeToUse.slice(0, 3));

    //     const mapped = dataBeforeToUse.map((item, index) => {
    //         // Estructura esperada: {fecha: "2025-01-24", cantidad: 407} o {hora: "14:00", cantidad: 407}
    //         if (item.fecha !== undefined && item.cantidad !== undefined) {
    //             return {
    //                 date: item.fecha,
    //                 hour: item.hora,
    //                 count: item.cantidad
    //             };
    //         }

    //         // Si ya viene con la estructura esperada por el gráfico
    //         if (item.date !== undefined && item.count !== undefined) {
    //             return item;
    //         }

    //         // ✅ FALLBACK para casos inesperados
    //         return {
    //             date: item.fecha || item.date || `Período ${index + 1}`,
    //             hour: item.hora || item.hour || `${index}:00`,
    //             count: item.cantidad || item.count || 0
    //         };
    //     });

    //     console.log('🔍 Datos mapeados en AlertaFrecuencia (anterior):', mapped.slice(0, 3));
    //     return mapped;
    // }, [dataBeforeToUse]);

    const processedBeforeData = useMemo(() => {
        if (!dataBeforeToUse || dataBeforeToUse.length === 0) return [];

        //console.log('🔍 Datos originales recibidos en AlertaFrecuencia (anterior):', dataBeforeToUse.slice(0, 3));

        const mapped = dataBeforeToUse.map((item, index) => {
            // Estructura esperada: {fecha: "2025-01-24", cantidad: 407} o {hora: "14:00", cantidad: 407}
            if (item.fecha !== undefined && item.cantidad !== undefined) {
                return {
                    date: item.fecha,    // ✅ ya convertida si es omisiones
                    hour: item.hora,     // ✅ ya convertida si es omisiones
                    count: item.cantidad
                };
            }

            // Si ya viene con la estructura esperada por el gráfico
            if (item.date !== undefined && item.count !== undefined) {
                return item;
            }

            // ✅ FALLBACK para casos inesperados
            return {
                date: item.fecha || item.date || `Período ${index + 1}`,
                hour: item.hora || item.hour || `${index}:00`,
                count: item.cantidad || item.count || 0
            };
        });

        //console.log('🔍 Datos mapeados en AlertaFrecuencia (anterior):', mapped.slice(0, 3));
        return mapped;
    }, [dataBeforeToUse, esOmisiones]);


    // ✅ FUNCIÓN PARA MANEJAR EL TOGGLE DE LAS LEYENDAS
    const handleLegendToggle = name => {
        if (chartRef.current && chartRef.current.getEchartsInstance) {
            chartRef.current.getEchartsInstance().dispatchAction({
                type: 'legendToggleSelect',
                name
            });
        }
    };

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <div className="position-relative">
            <Form.Control ref={ref} onClick={onClick} value={value} onChange={() => { }} />
        </div>
    ));

    const getLoading = () => <Row>
        {/* <ProgressBarWithComponents
            loadingComponents={loadingComponents}
            calculateTotalProgress={calculateTotalProgress}
            debugMetrics={debugMetrics}
        />*/}
        <ProgressBar
            style={{ height: 10, marginTop: 30 }}
            id='prg_master'
            className="shadow-none rounded-4"
            variant='success'>
            {totalCarga.map((group, index) => (
                <ProgressBar
                    style={{ backgroundColor: group.color }}
                    now={group.percent / totalCarga.length}
                    key={group.title}
                    animated={group.animated}
                    className={classNames('overflow-visible position-relative', {
                        'rounded-end rounded-pill': index === 0,
                        'rounded-start rounded-pill': index === totalCarga.length - 1,
                        'border-end border-100 border-0': index !== totalCarga.length - 1,
                        'rounded-0': index !== totalCarga.length - 1 && index !== 0
                    })}
                />
            ))}
        </ProgressBar>
    </Row>;
    const handleComparativa = () => {
        const _fechaInicio = dayjs(startDate.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss");
        const _fechaFin = dayjs(endDate.getTime()).format("YYYY-MM-DDTHH:mm:ss");
        const _fechaInicioBefore = dayjs(startDateBefore.getTime()).tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss");
        const _fechaFinBefore = dayjs(endDateBefore.getTime()).format("YYYY-MM-DDTHH:mm:ss");
        store.editarFiltrosAfter({
            fecha_inicio: _fechaInicio,
            fecha_fin: _fechaFin,
        });
        store.editarFiltrosBefore({
            fecha_inicio: _fechaInicioBefore,
            fecha_fin: _fechaFinBefore,
        });
        store.setFirstLoad(false);
    };

    const style = {
        display: "-webkit-box",
        WebkitLineClamp: 1, // Limita a 2 líneas
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };

    return (
        <Card style={{ height: '500px' }}>
            <FalconCardHeader
                className='p-3'
                title={alertaFiltrada != null
                    ? `Comparativo de alertas: ${vehiculoFiltrado != null ? vehiculoFiltrado.title + " / " : ""}${alertaFiltrada}`
                    : `Comparativo de alertas ${vehiculoFiltrado != null ? ": " + vehiculoFiltrado.title : ""}`}
                // title='Comparativo de alertas'
                titleTag="h6"
                light
                endEl={
                    <div className="d-flex gap-2 flex-wrap">
                        {/* <Button variant="primary" onClick={handleComparativa}>Generar</Button> */}
                    </div>
                }
            />
            <Card.Body className='px-3'>
                <div xs={12} className='d-flex flex-nowrap px-3 pb-2'>
                    <Col xs={5.75}>
                        <Row>
                            <Col xs={12}>
                                <Form.Check
                                    type="checkbox"
                                    id="selectedPeriod"
                                    className="mb-0 d-flex"
                                >
                                    <Form.Check.Input
                                        type="checkbox"
                                        className="form-check-input-primary"
                                        onClick={() => handleLegendToggle('Período Actual')}
                                        defaultChecked
                                    />
                                    <Form.Check.Label className="ps-2 fs-11 text-600 mb-0 d-flex flex-nowrap">
                                        <div title={"Período anterior:"} className='pe-2' style={{ ...style, maxWidth: '120px' }}>Período actual:</div>
                                        <span className="text-1100 text-nowrap"> {(total || 0).toLocaleString('es-MX')} alertas</span>
                                    </Form.Check.Label>
                                </Form.Check>
                            </Col>
                            <Col xs={6} className='py-0'>
                                <Form.Group>
                                    <Form.Label style={style} title='Fecha inicial'>Fecha inicial</Form.Label>
                                    <DatePicker
                                        selected={startDate}
                                        maxDate={endOfDay}
                                        onChange={handleStartDateChange}
                                        customInput={<ExampleCustomInput />}
                                        timeIntervals={5}
                                        dateFormat="dd/MM/yyyy HH:mm:ss"
                                        renderCustomHeader={renderIniHeader}
                                        popperClassName="custom-datepicker-popper"
                                        fixedHeight
                                        locale="es" // 📌 Localización en español
                                        timeCaption="Hora" // 
                                        portalId="root-portal-actual-inicio"
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={6} >
                                <Form.Group>
                                    <Form.Label style={style} title='Fecha final'>Fecha final</Form.Label>
                                    <DatePicker
                                        selected={endDate}
                                        //minDate={startDate}
                                        minTime={
                                            endDate.getDate() === startDate.getDate()
                                                ? startDate
                                                : new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 0, 0, 0)
                                        }
                                        maxDate={endOfDay}
                                        maxTime={endOfDay}
                                        minDate={startDate}
                                        onChange={handleEndDateChange}
                                        customInput={<ExampleCustomInput />}
                                        timeIntervals={5}
                                        dateFormat="dd/MM/yyyy HH:mm:ss"
                                        renderCustomHeader={renderEndHeader}
                                        popperClassName="custom-datepicker-popper"
                                        fixedHeight
                                        locale="es" // 📌 Localización en español
                                        timeCaption="Hora" // 
                                        portalId="root-portal-actual-fin"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                    </Col>
                    <Col xs={0.5} className='px-4'>
                        <Divider orientation="vertical" variant="middle" style={{ height: '100%' }}></Divider>
                    </Col>
                    <Col xs={5.75}>
                        <Row md={12}>
                            <Col xs={12}>
                                <Form.Check
                                    type="checkbox"
                                    id="previousMonth"
                                    className="mb-0 d-flex ps-0"
                                >
                                    <Form.Check.Input
                                        type="checkbox"
                                        className="ms-0 form-check-input-warning opacity-75"
                                        onClick={() => handleLegendToggle('Período Anterior')}
                                        defaultChecked
                                    />
                                    <Form.Check.Label className="ps-2 fs-11 text-600 mb-0 d-flex flex-nowrap">
                                        <div title={"Período anterior:"} className='pe-2' style={{ ...style, maxWidth: '120px' }}>Período anterior:</div>
                                        <span className="text-1100 text-nowrap"> {(totalBefore || 0).toLocaleString('es-MX')} Alertas</span>
                                    </Form.Check.Label>
                                </Form.Check>
                            </Col>
                            <Col xs={6} className='py-0'>
                                <Form.Group>
                                    <Form.Label style={style} title='Fecha inicial'>Fecha inicial</Form.Label>
                                    <DatePicker
                                        selected={startDateBefore}
                                        onChange={handleStartDateBeforeChange}
                                        maxDate={endOfDay}
                                        customInput={<ExampleCustomInput />}
                                        timeIntervals={5}
                                        dateFormat="dd/MM/yyyy HH:mm:ss"
                                        renderCustomHeader={renderIniHeaderBefore}
                                        popperClassName="custom-datepicker-popper"
                                        fixedHeight
                                        locale="es" // 📌 Localización en español
                                        timeCaption="Hora" // 
                                        portalId="root-portal-anterior-inicio"

                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={6} style={{ opacity: 0.5 }}>
                                <Form.Group>
                                    <Form.Label style={style} title='Fecha final'>Fecha final</Form.Label>
                                    <DatePicker
                                        selected={endDateBefore}
                                        onChange={handleEndDateBeforeChange}
                                        customInput={<ExampleCustomInput />}
                                        timeIntervals={5}
                                        dateFormat="dd/MM/yyyy HH:mm:ss"
                                        renderCustomHeader={renderEndHeaderBefore}
                                        popperClassName="custom-datepicker-popper"
                                        fixedHeight
                                        disabled
                                        locale="es" // 📌 Localización en español
                                        timeCaption="Hora" // 
                                        portalId="root-portal-anterior-fin"
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Col>
                </div>
                {totalCarga.length > 0 && isLoading === true ? <div className='position-absolute' style={{ left: '40px', right: '40px' }}>
                    {getLoading()}
                </div> : <div></div>}
                <div className='pt-4'>
                    <AlertaFrecuenciaChart
                        data={processedCurrentData}
                        dataBefore={processedBeforeData}
                        ref={chartRef}
                        isSingleDay={isSingleDay}

                    />
                </div>
                <Row className='d-flex pt-2 flex-nowrap'>

                    <Col md={7} className='me-auto p-2'>
                        <div className='text-start ps-3 '>
                            <h6 className="label-detail-card py-2"> {alertaFiltrada !== null ? `${alertaFiltrada} ` : "Total de alertas: "} {((totalBefore || 0) + (total || 0)).toLocaleString('es-MX')}</h6>
                        </div>
                    </Col>

                    <Col md={5} className='justify-content-end'>
                        <Button className='float-end' variant="primary" onClick={handleComparativa} disabled={isLoading}>Generar</Button>
                    </Col>
                </Row>
            </Card.Body>
        </Card >
    );
};

AlertaFrecuencia.propTypes = {
    // Datos agrupados por día
    data: PropTypes.arrayOf(
        PropTypes.shape({
            fecha: PropTypes.string.isRequired,
            cantidad: PropTypes.number.isRequired
        })
    ).isRequired,
    // Datos agrupados por hora (cuando hay un solo día)
    dataHours: PropTypes.arrayOf(
        PropTypes.shape({
            fecha: PropTypes.string,
            hora: PropTypes.string,
            cantidad: PropTypes.number.isRequired
        })
    ),
    // Datos del periodo anterior agrupados por día
    dataBefore: PropTypes.arrayOf(
        PropTypes.shape({
            fecha: PropTypes.string,
            cantidad: PropTypes.number
        })
    ),
    // Datos del periodo anterior agrupados por hora
    dataBeforeHours: PropTypes.arrayOf(
        PropTypes.shape({
            fecha: PropTypes.string,
            hora: PropTypes.string,
            cantidad: PropTypes.number
        })
    ),
    total: PropTypes.number,
    totalBefore: PropTypes.number,
    isSingleDay: PropTypes.bool,
    isSingleDayBefore: PropTypes.bool
};

export default AlertaFrecuencia;


// import React, { useRef, useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
// import { Card, Col, Form, Row } from 'react-bootstrap';
// import CardDropdown from '../../../../../components/common/CardDropdown';
// import AlertaFrecuenciaChart from './AlertaFrecuenciaChart';
// import Flex from '../../../../../components/common/Flex';

// // Crea el worker usando import.meta.url para Vite/CRA modernos
// const createWorker = () => {
//     return new Worker(
//         new URL('./alertaFrecuenciaWorker.js', import.meta.url)
//     );
// };

// const AlertaFrecuencia = ({ data, dataBefore }) => {
//     const chartRef = useRef(null);

//     // Estados para los datos agrupados
//     const [groupedByDate, setGroupedByDate] = useState([]);
//     const [groupedByHour, setGroupedByHour] = useState([]);
//     const [groupedByDateBefore, setGroupedByDateBefore] = useState([]);
//     const [groupedByHourBefore, setGroupedByHourBefore] = useState([]);

//     // Agrupar periodo actual por fecha
//     useEffect(() => {
//         const worker = createWorker();
//         worker.onmessage = (e) => setGroupedByDate(e.data);
//         worker.postMessage({ data, type: 'date' });
//         return () => worker.terminate();
//     }, [data]);

//     // Agrupar periodo actual por hora
//     useEffect(() => {
//         const worker = createWorker();
//         worker.onmessage = (e) => setGroupedByHour(e.data);
//         worker.postMessage({ data, type: 'hour' });
//         return () => worker.terminate();
//     }, [data]);

//     // Agrupar periodo anterior por fecha
//     useEffect(() => {
//         const worker = createWorker();
//         worker.onmessage = (e) => setGroupedByDateBefore(e.data);
//         worker.postMessage({ data: dataBefore, type: 'date' });
//         return () => worker.terminate();
//     }, [dataBefore]);

//     // Agrupar periodo anterior por hora
//     useEffect(() => {
//         const worker = createWorker();
//         worker.onmessage = (e) => setGroupedByHourBefore(e.data);
//         worker.postMessage({ data: dataBefore, type: 'hour' });
//         return () => worker.terminate();
//     }, [dataBefore]);

//     // Determinar si solo hay un día en los datos actuales
//     const uniqueDates = [...new Set(groupedByDate.map((item) => item.date))];
//     const isSingleDay = uniqueDates.length === 1;

//     // Determinar si solo hay un día en los datos del periodo anterior
//     const uniqueDatesBefore = [...new Set(groupedByDateBefore.map((item) => item.date))];
//     const isSingleDayBefore = uniqueDatesBefore.length === 1;

//     const handleLegendToggle = name => {
//         if (chartRef.current && chartRef.current.getEchartsInstance) {
//             chartRef.current.getEchartsInstance().dispatchAction({
//                 type: 'legendToggleSelect',
//                 name
//             });
//         }
//     };

//     return (
//         <Card>
//             <Card.Header>
//                 <Row className="flex-between-center g-0">
//                     <Col xs="auto">
//                         <h6 className="mb-0">Comparativo de alertas</h6>
//                     </Col>
//                     <Col md="auto" className="order-1 order-md-0 mt-3 mt-md-0">
//                         <Flex className="flex-wrap gap-2 gap-md-3">
//                             <Form.Check
//                                 type="checkbox"
//                                 id="selectedPeriod"
//                                 className="mb-0 d-flex"
//                             >
//                                 <Form.Check.Input
//                                     type="checkbox"
//                                     className="form-check-input-primary"
//                                     onClick={() => handleLegendToggle('Período Actual')}
//                                     defaultChecked
//                                 />
//                                 <Form.Check.Label className="ps-2 fs-11 text-600 mb-0">
//                                     Período actual:
//                                     <span className="text-1100"> {data.length} alertas</span>
//                                 </Form.Check.Label>
//                             </Form.Check>
//                             <Form.Check
//                                 type="checkbox"
//                                 id="previousMonth"
//                                 className="mb-0 d-flex ps-0"
//                             >
//                                 <Form.Check.Input
//                                     type="checkbox"
//                                     className="ms-0 form-check-input-warning opacity-75"
//                                     onClick={() => handleLegendToggle('Período Anterior')}
//                                     defaultChecked
//                                 />
//                                 <Form.Check.Label className="ps-2 fs-11 text-600 mb-0">
//                                     Período anterior:
//                                     <span className="text-1100"> {dataBefore.length} Alertas</span>
//                                 </Form.Check.Label>
//                             </Form.Check>
//                         </Flex>
//                     </Col>
//                     {/**
//                      * <Col xs="auto">
//                         <CardDropdown />
//                     </Col>
//                      */}
//                 </Row>
//             </Card.Header>
//             <Card.Body className="pe-xxl-0">
//                 <AlertaFrecuenciaChart
//                     data={isSingleDay ? groupedByHour : groupedByDate}
//                     ref={chartRef}
//                     isSingleDay={isSingleDay}
//                     style={{ height: '18.625rem' }}
//                     dataBefore={isSingleDayBefore ? groupedByHourBefore : groupedByDateBefore}
//                 />
//             </Card.Body>
//         </Card>
//     );
// };

// AlertaFrecuencia.propTypes = {
//     data: PropTypes.arrayOf(
//         PropTypes.shape({
//             fecha: PropTypes.string.isRequired,
//         })
//     ).isRequired,
//     dataBefore: PropTypes.arrayOf(
//         PropTypes.shape({
//             fecha: PropTypes.string.isRequired,
//         })
//     ).isRequired,
//     Frecuencia: PropTypes.array
// };

// export default AlertaFrecuencia;













// import React, { useRef, useMemo,useState } from 'react';
// import PropTypes from 'prop-types';
// import { Card, Col, Form, Row } from 'react-bootstrap';
// import dayjs from 'dayjs';
// import CardDropdown from '../../../../../components/common/CardDropdown';
// import AlertaFrecuenciaChart from './AlertaFrecuenciaChart';
// import Flex from '../../../../../components/common/Flex';
// import { sortBy } from 'underscore';


// const createWorker = () => {
//     return new Worker(
//         new URL('./alertaFrecuenciaWorker.js', import.meta.url)
//     );
// };

// const groupByDate = (data) => {
//     const grouped = {};

//     const datosOrdenados = sortBy(data, 'fecha')

//     datosOrdenados.forEach((alert) => {

//         const formattedDate = dayjs(alert.fecha, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD'); // 🔹 Agrupar solo por día
//         if (!grouped[formattedDate]) {
//             grouped[formattedDate] = 0;
//         }
//         grouped[formattedDate] += 1;
//     });

//     return Object.entries(grouped).map(([date, count]) => ({ date, count }));
// };

// const groupByHour = (data) => {
//     const grouped = {};

//     const datosOrdenados = sortBy(data, 'fecha')

//     datosOrdenados.forEach((alert) => {
//         const formattedHour = dayjs(alert.fecha, 'YYYY-MM-DD HH:mm:ss').format('HH:00'); // 🔹 Agrupar solo por hora
//         if (!grouped[formattedHour]) {
//             grouped[formattedHour] = 0;
//         }
//         grouped[formattedHour] += 1;
//     });

//     return Object.entries(grouped).map(([hour, count]) => ({ hour, count }));
// };

// const AlertaFrecuencia = ({ data, dataBefore }) => {

//     const chartRef = useRef(null);
//     // 🔹 Agrupar alertas
//     const groupedByDate = useMemo(() => groupByDate(data), [data]);
//     const groupedByHour = useMemo(() => groupByHour(data), [data]);

//     // 🔹 Determinar si solo hay un día en los datos
//     const uniqueDates = [...new Set(groupedByDate.map((item) => item.date))];
//     const isSingleDay = uniqueDates.length === 1;

//     //----Periodo Anterior------

//     // 🔹 Agrupar alertas del periodo anterior
//     const groupedByDateBefore = useMemo(() => groupByDate(dataBefore), [dataBefore]);
//     const groupedByHourBefore = useMemo(() => groupByHour(dataBefore), [dataBefore]);

//     // 🔹 Determinar si solo hay un día en los datos en periodo anterior
//     const uniqueDatesBefore = [...new Set(groupedByDateBefore.map((item) => item.date))];
//     const isSingleDayBefore = uniqueDatesBefore.length === 1;

//     const handleLegendToggle = name => {
//         chartRef.current.getEchartsInstance().dispatchAction({
//             type: 'legendToggleSelect',
//             name
//         });
//     };

//     return (
//         <Card>
//             <Card.Header>
//                 <Row className="flex-between-center g-0">
//                     <Col xs="auto">
//                         <h6 className="mb-0">Comparativo de alertas</h6>
//                     </Col>
//                     <Col md="auto" className="order-1 order-md-0 mt-3 mt-md-0">
//                         <Flex className="flex-wrap gap-2 gap-md-3">
//                             <Form.Check
//                                 type="checkbox"
//                                 id="selectedPeriod"
//                                 className="mb-0 d-flex"
//                             >
//                                 <Form.Check.Input
//                                     type="checkbox"
//                                     className="form-check-input-primary"
//                                     onClick={() => handleLegendToggle('Período Actual')}
//                                     defaultChecked
//                                 />
//                                 <Form.Check.Label className="ps-2 fs-11 text-600 mb-0">
//                                     Período actual:
//                                     <span className="text-1100"> {data.length} alertas</span>
//                                 </Form.Check.Label>
//                             </Form.Check>
//                             <Form.Check
//                                 type="checkbox"
//                                 id="previousMonth"
//                                 className="mb-0 d-flex ps-0"
//                             >
//                                 <Form.Check.Input
//                                     type="checkbox"
//                                     className="ms-0 form-check-input-warning opacity-75"
//                                     onClick={() => handleLegendToggle('Período Anterior')}
//                                     defaultChecked
//                                 />
//                                 <Form.Check.Label className="ps-2 fs-11 text-600 mb-0">
//                                     Período anterior:
//                                     <span className="text-1100"> {dataBefore.length} Alertas</span>
//                                 </Form.Check.Label>
//                             </Form.Check>
//                         </Flex>
//                     </Col>
//                     {/**
//                      * <Col xs="auto">
//                         <CardDropdown />
//                     </Col>
//                      */}
//                 </Row>
//             </Card.Header>
//             <Card.Body className="pe-xxl-0">
//                 <AlertaFrecuenciaChart
//                     data={isSingleDay ? groupedByHour : groupedByDate} // 🔹 Mostrar en horas si solo hay un día
//                     ref={chartRef}
//                     isSingleDay={isSingleDay} // 🔹 Pasar esta información al gráfico
//                     style={{ height: '18.625rem' }}
//                     dataBefore={isSingleDayBefore ? groupedByHourBefore : groupedByDateBefore}  // 🔹 Mostrar en horas si solo hay un día del periodo anterior
//                 />
//             </Card.Body>
//         </Card>
//     );
// };

// AlertaFrecuencia.propTypes = {
//     data: PropTypes.arrayOf(
//         PropTypes.shape({
//             fecha: PropTypes.string.isRequired,
//         })
//     ).isRequired,
//     dataBefore: PropTypes.arrayOf(
//         PropTypes.shape({
//             fecha: PropTypes.string.isRequired,
//         })
//     ).isRequired,
//     Frecuencia: PropTypes.array
// };

// export default AlertaFrecuencia;
